/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getTmpUrlRequest: ['data'],
  getTmpUrlSuccess: ['response'],
  getTmpUrlFailure: null,
  getFacebookRequest: ['data'],
  getFacebookSuccess: ['response'],
  getFacebookFailure: null,
  shareRequest: ['data'],
  shareSuccess: ['payload'],
  shareFailure: null
})

export const ShareTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  dataStatus: null,
  fetching: null,
 
  error: null
})

/* ------------- Selectors ------------- */

export const ShareSelectors = {
  getData: state => state.data
}

/* ------------- Reducers ------------- */


export const getFacebookRequest = (state, action) =>
  state.merge({ fetching: true,  dataStatus: null })

// successful api lookup
export const getFacebookSuccess = (state, action) => {
  const { response: { data:{ data } } }= action
  console.tron.display({
  name: `getFacebookSuccess redux`,
   preview :``,
  value: {
  state: action
  }
  })
  
  return state.merge({ fetching: false, error: null, dataStatus :data })
}

// Something went wrong somewhere.
export const getFacebookFailure = state =>
  state.merge({ fetching: false, error: true, dataStatus: null })
export const getTmpUrlRequest = (state, action) =>
  state.merge({ fetching: true,  dataStatus: null })

// successful api lookup
export const getTmpUrlSuccess = (state, action) => {
  const { response: { data:{ data } } }= action
  console.tron.display({
  name: `getTmpUrlSuccess sucess redux`,
   preview :``,
  value: {
  state: action
  }
  })
  
  return state.merge({ fetching: false, error: null, dataStatus :data })
}

// Something went wrong somewhere.
export const getTmpUrlFailure = state =>
  state.merge({ fetching: false, error: true, dataStatus: null })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_FACEBOOK_REQUEST]: getFacebookRequest,
  [Types.GET_FACEBOOK_SUCCESS]: getFacebookSuccess,
  [Types.GET_FACEBOOK_FAILURE]: getFacebookFailure,

  [Types.GET_TMP_URL_REQUEST]: getTmpUrlRequest,
  [Types.GET_TMP_URL_SUCCESS]: getTmpUrlSuccess,
  [Types.GET_TMP_URL_FAILURE]: getTmpUrlFailure
})
